// src/pages/Home.js
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import HeroSection from "../components/HeroSection/HeroSection";
import TrustSection from "../components/TrustSection/TrustSection";
import TimelineSection from "../components/TimelineSection/TimelineSection";
import GallerySection from "../components/GallerySection/GallerySection";
import ServicesSection from "../components/ServicesSection/ServicesSection";
import SectionDivider from "../components/SectionDivider/SectionDivider";

import "../styles/Home.css";

export default function Home() {
  const navigate = useNavigate();
  const rootRef = useRef(null);

  // Handle internal links (your existing logic)
  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;

    const onClick = (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const anchor = e.target.closest("a");
      if (!anchor) return;

      const href = anchor.getAttribute("href");
      const target = anchor.getAttribute("target");

      if (!href || target === "_blank" || anchor.hasAttribute("download")) return;
      if (href.startsWith("tel:") || href.startsWith("mailto:")) return;
      if (href.startsWith("#")) return;

      const url = new URL(href, window.location.origin);

      if (url.origin !== window.location.origin) return;

      e.preventDefault();
      navigate(url.pathname + url.search + url.hash);
    };

    el.addEventListener("click", onClick);
    return () => el.removeEventListener("click", onClick);
  }, [navigate]);

  return (
    <main className="home-wrapper" ref={rootRef}>
      <Helmet>
        <title>DeClerck’s Goldens | Golden Retriever Puppies & Stud Services</title>
        <meta
          name="description"
          content="DeClerck’s Goldens offers healthy, family-raised Golden Retriever puppies and professional stud services. Explore our adoption journey, services, and gallery."
        />

        {/* Open Graph for social media */}
        <meta property="og:title" content="DeClerck’s Goldens | Golden Retriever Puppies & Stud Services" />
        <meta property="og:description" content="Family-raised Golden Retriever puppies and trusted stud services. Learn more about our adoption process." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.declercksgoldens.com/" />
        <meta property="og:image" content="https://www.declercksgoldens.com/hero-bg-square.png" />

        {/* Twitter card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="DeClerck’s Goldens | Golden Retriever Puppies & Stud Services" />
        <meta name="twitter:description" content="Healthy Golden Retriever puppies and trusted stud services from DeClerck’s Goldens." />
        <meta name="twitter:image" content="https://www.declercksgoldens.com/hero-bg-square.png" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.declercksgoldens.com/" />
      </Helmet>

      {/* Hero */}
      <HeroSection />

      <SectionDivider />

      {/* Trust / Care */}
      <TrustSection />

      <SectionDivider />

      {/* Adoption Journey Timeline */}
      <TimelineSection />

      <SectionDivider />

      {/* Gallery */}
      <GallerySection />

      <SectionDivider />

      {/* Services */}
      <ServicesSection />

      <SectionDivider />
    </main>
  );
}
